<template>
  <section>
    <EditDialog ref="editDialog" :orgId="orgId" @sub="handleEditSub" />
    <ChooseInsurance
      :otherSearchData="{
        costType: 2006,
        orgId,
      }"
      ref="chooseInsurance"
      :customShow="true"
      @change="handleEditSub"
    />
    <span class="primary cur addBtn" @click="showEdit()">添加</span>
    <span class="primary cur" @click="showChoose()">选择</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        >
          <section slot-scope="scope">
            <section v-if="scope.column.property === 'serviceName'">
              <span
                v-for="(item,index) in insuranceCompanyOptions"
                :key="index"
              >{{scope.row[scope.column.property] === item.value ? item.label : ''}}</span>
            </section>
            <section v-else>{{scope.row[scope.column.property]}}</section>
          </section>
        </el-table-column>
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions>
                <span class="primary cur" @click="showEdit(scope.row)" v-show="!scope.row.id">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions>
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
import ChooseInsurance from 'components/choose/insurance';
import { insuranceCompanyOptions } from '@qx/utils/enum';
export default {
  components: {
    EditDialog,
    ChooseInsurance,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    orgId: {
      type: Number,
    },
    resultVal: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      insuranceCompanyOptions,
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'certificatesInsuranceTypeName',
            label: '保险类型',
          },
          {
            prop: 'agentCompany',
            label: '被保险人',
          },
          {
            prop: 'insuranceCode',
            label: '保单号',
          },
          {
            prop: 'insuranceStartDate',
            label: '起保日期',
          },
          {
            prop: 'insuranceEndDate',
            label: '终保日期',
          },
          {
            prop: 'serviceName',
            label: '保险公司',
          },
          {
            prop: 'payAmt',
            label: '保费（元）',
          },
          {
            prop: 'payRemark',
            label: '费用说明',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    showChoose () {
      this.$refs.chooseInsurance.show();
    },
    handleEditSub (item) {
      if (!item.form) { // 选择
        const resultValIds = this.resultVal.map((item) => item.id);
        item.forEach((d) => {
          if (resultValIds.indexOf(d.id) === -1) {
            d.busiType = d.certificatesInsuranceType;
            d.payAmt = d.certificatesInsuranceFee / 100;
            this.resultVal.push(d);
          }
        });
      } else if (item.originData) { // 修改
        const index = this.resultVal.indexOf(item.originData);
        this.resultVal.splice(index, 1, item.form);
      } else { // 新增
        this.resultVal.push(item.form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style scoped lang="scss">
.addBtn {
  margin-right: 16px;
}
</style>
